import React, { useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { useAllowRegistration } from "@/hooks";
import { Grid, Typography, Stack } from "@mui/material";
import { Link } from "react-router";

export const LoginLinkSection = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { allowRegistration } = useAllowRegistration();

  return (
    <>
      <Grid size={{ xs: 12 }}>
        {allowRegistration && (
          <Stack
            direction="row"
            sx={{ alignItems: "baseline", justifyContent: "center" }}
          >
            <Typography>{gettext("Don't Have An Account Yet?")}</Typography>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              &nbsp;
            </Typography>
            <Typography
              component={Link}
              to="/auth/register"
              sx={{
                textDecoration: "none",
                fontSize: 16,
                fontWeight: 500,
                color: "primary",
              }}
            >
              {gettext("Sign Up")}
            </Typography>
          </Stack>
        )}
        <Stack
          direction="row"
          sx={{ alignItems: "baseline", justifyContent: "center" }}
        >
          <Typography
            component={Link}
            to="/auth/forgot-password"
            sx={{
              textDecoration: "none",
              fontSize: 16,
              fontWeight: 500,
              color: "primary",
            }}
          >
            {gettext("Forgot Your Password?")}
          </Typography>
        </Stack>
      </Grid>
    </>
  );
};
